const languages = [
  {
    language: 'en',
    title: 'English'
  },
  {
    language: 'es',
    title: 'Español (Spanish)'
  },
  {
    language: 'pt',
    title: 'Português (Portuguese)'
  },
  {
    language: 'tr',
    title: 'Türk (Turkish)'
  },
  {
    language: 'zh',
    title: '中文 (Chinese - Simplified)'
  },
  {
    language: 'fr',
    title: 'Français (French)'
  },
  {
    language: 'it',
    title: 'Italiano (Italian)'
  },
  {
    language: 'ru',
    title: 'Pусский (Russian)'
  },
  {
    language: 'th',
    title: 'ไทย (Thai)'
  },
  {
    language: 'ja',
    title: '日本語 (Japanese)'
  },
  {
    language: 'de',
    title: 'Deutsche (German)'
  }
]

export {
  languages
}



// WEBPACK FOOTER //
// ./src/plugins/factory/Language.js